import React from "react";
import Request from "../../../../../../api/Requests";

const getUsersAccessList = (params) => {
    
    return Request('venues-users/list-users-venues', 'GET', params, true);
}


const deleteUsersAccess = (params) => {
    
    return Request('venues-users/delete-user-venues', 'POST', params, true);
}

const postAddMemberVenue = (params) => {
    return Request('venues-users/add-member-venue', 'POST', params, true);
}


export default {
    getUsersAccessList,
    deleteUsersAccess,
    postAddMemberVenue
}